var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-panel",class:{ expanded: _vm.expanded }},[_c('div',{staticClass:"container",on:{"click":function($event){_vm.expanded = !_vm.expanded}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }